import * as THREE from 'three';
import { labelPlane } from '../materials/MaterialFactory';
import { markInteractive } from './BaseComponent';

export class AxialResistor extends THREE.Group {
  constructor(id: 'R1' | 'R2' | 'R3', value: string, role: string, colors: number[]) {
    super();
    this.name = `${id} ${value}`;
    const leadMat = new THREE.MeshStandardMaterial({ color: 0xbac2c7, metalness: 0.9, roughness: 0.2 });
    const leadGeo = new THREE.CylinderGeometry(0.045, 0.045, 1.6, 10);
    for (const x of [-1.5, 1.5]) {
      const lead = new THREE.Mesh(leadGeo, leadMat);
      lead.rotation.z = Math.PI / 2;
      lead.position.x = x;
      lead.position.y = 0.67;
      this.add(lead);
    }
    const body = new THREE.Mesh(
      new THREE.CapsuleGeometry(0.35, 1.45, 6, 16),
      new THREE.MeshStandardMaterial({ color: 0xd8b77c, roughness: 0.66 })
    );
    body.rotation.z = Math.PI / 2;
    body.position.y = 0.67;
    body.castShadow = true;
    this.add(body);
    colors.forEach((color, index) => {
      const ring = new THREE.Mesh(
        new THREE.CylinderGeometry(0.365, 0.365, 0.18, 20),
        new THREE.MeshStandardMaterial({ color, roughness: 0.5, metalness: color === 0xd4af37 ? 0.5 : 0 })
      );
      ring.rotation.z = Math.PI / 2;
      ring.position.set(-0.65 + index * 0.42, 0.67, 0);
      this.add(ring);
    });
    const label = labelPlane([`${id}  ${value}`, role], 2.8, 0.62, { background: '#18232d', color: '#fff4cf', accent: '#d8b77c' });
    label.rotation.x = -Math.PI / 2;
    label.position.set(0, 0.26, 0.72);
    this.add(label);
    markInteractive(this, {
      id, name: `${id} ${role}`, english: id === 'R3' ? 'LED Current-limiting Resistor' : 'Pull-up Resistor',
      model: value, function: id === 'R3' ? '限制 LED 电流，保护 LED 与芯片输出。' : '开关断开时把输入稳定拉到 VCC 高电平。',
      connection: id === 'R3' ? '芯片输出 1Y 与 LED 阴极路径之间。' : `VCC 与输入节点之间。`,
      mistake: id === 'R3' ? '省略限流电阻会导致过大电流。' : '省略上拉电阻会让输入悬空、状态不稳定。',
      tip: id === 'R3' ? '色环红-黑-红-金，约 2kΩ。' : '色环棕-黑-橙-金，10kΩ。'
    });
  }
}
